export class GameObject {
  public x: number = 0;
  public y: number = 0;
  public rotation: number = 0;
  public hidden: boolean = false;

  constructor({ x, y }: { x: number, y: number }) {
    this.x = x
    this.y = y
  }
} 